export const ENTITY_NAME_MIN_LENGTH = 1;
export const ENTITY_NAME_MAX_LENGTH = 150;
/**
 * Allowed characters: Unicode letters, numbers, regular spaces, hyphens,
 * underscores, periods, parentheses, ampersands, commas, apostrophes.
 */
export const ENTITY_NAME_ALLOWED_PATTERN = /^[\p{L}\p{N} \-_.,&'()]+$/u;
/**
 * Must contain at least one Unicode letter or number.
 */
export const ENTITY_NAME_ALPHANUMERIC_PATTERN = /[\p{L}\p{N}]/u;
const CONSECUTIVE_SPACES_PATTERN = / {2,}/;
export function validateEntityName(name, entityLabel = 'Name') {
    if (name == null || name.trim().length === 0) {
        return { valid: false, error: `${entityLabel} is required` };
    }
    const trimmed = name.trim();
    if (trimmed.length > ENTITY_NAME_MAX_LENGTH) {
        return {
            valid: false,
            error: `${entityLabel} must be at most ${ENTITY_NAME_MAX_LENGTH} characters long`,
        };
    }
    if (!ENTITY_NAME_ALLOWED_PATTERN.test(trimmed)) {
        return {
            valid: false,
            error: `${entityLabel} can only contain letters, numbers, spaces, hyphens, underscores, periods, parentheses, ampersands, commas, and apostrophes`,
        };
    }
    if (!ENTITY_NAME_ALPHANUMERIC_PATTERN.test(trimmed)) {
        return {
            valid: false,
            error: `${entityLabel} must contain at least one letter or number`,
        };
    }
    if (CONSECUTIVE_SPACES_PATTERN.test(trimmed)) {
        return {
            valid: false,
            error: `${entityLabel} must not contain consecutive spaces`,
        };
    }
    return { valid: true };
}
const DISALLOWED_CHARS_PATTERN = /[^\p{L}\p{N} \-_.,&'()]/gu;
/**
 * Coerces an arbitrary string into a value that passes ENTITY_NAME_ALLOWED_PATTERN
 * by replacing disallowed characters with spaces, collapsing runs of whitespace,
 * and trimming. Returns an empty string if no allowed characters remain.
 */
export function sanitizeEntityName(name) {
    if (name == null)
        return '';
    return name
        .replace(DISALLOWED_CHARS_PATTERN, ' ')
        .replace(CONSECUTIVE_SPACES_PATTERN, ' ')
        .trim();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW50aXR5TmFtZVZhbGlkYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2VudGl0eU5hbWVWYWxpZGF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLHNCQUFzQixHQUFHLENBQUMsQ0FBQztBQUN4QyxNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRyxHQUFHLENBQUM7QUFFMUM7OztHQUdHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sMkJBQTJCLEdBQUcsNEJBQTRCLENBQUM7QUFFeEU7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxnQ0FBZ0MsR0FBRyxlQUFlLENBQUM7QUFFaEUsTUFBTSwwQkFBMEIsR0FBRyxPQUFPLENBQUM7QUFFM0MsTUFBTSxVQUFVLGtCQUFrQixDQUNoQyxJQUErQixFQUMvQixXQUFXLEdBQUcsTUFBTTtJQUVwQixJQUFJLElBQUksSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksRUFBRSxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUUsQ0FBQztRQUM3QyxPQUFPLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsR0FBRyxXQUFXLGNBQWMsRUFBRSxDQUFDO0lBQy9ELENBQUM7SUFFRCxNQUFNLE9BQU8sR0FBRyxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUM7SUFFNUIsSUFBSSxPQUFPLENBQUMsTUFBTSxHQUFHLHNCQUFzQixFQUFFLENBQUM7UUFDNUMsT0FBTztZQUNMLEtBQUssRUFBRSxLQUFLO1lBQ1osS0FBSyxFQUFFLEdBQUcsV0FBVyxvQkFBb0Isc0JBQXNCLGtCQUFrQjtTQUNsRixDQUFDO0lBQ0osQ0FBQztJQUVELElBQUksQ0FBQywyQkFBMkIsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQztRQUMvQyxPQUFPO1lBQ0wsS0FBSyxFQUFFLEtBQUs7WUFDWixLQUFLLEVBQUUsR0FBRyxXQUFXLDZIQUE2SDtTQUNuSixDQUFDO0lBQ0osQ0FBQztJQUVELElBQUksQ0FBQyxnQ0FBZ0MsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQztRQUNwRCxPQUFPO1lBQ0wsS0FBSyxFQUFFLEtBQUs7WUFDWixLQUFLLEVBQUUsR0FBRyxXQUFXLDZDQUE2QztTQUNuRSxDQUFDO0lBQ0osQ0FBQztJQUVELElBQUksMEJBQTBCLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7UUFDN0MsT0FBTztZQUNMLEtBQUssRUFBRSxLQUFLO1lBQ1osS0FBSyxFQUFFLEdBQUcsV0FBVyxzQ0FBc0M7U0FDNUQsQ0FBQztJQUNKLENBQUM7SUFFRCxPQUFPLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRSxDQUFDO0FBQ3pCLENBQUM7QUFFRCxNQUFNLHdCQUF3QixHQUFHLDJCQUEyQixDQUFDO0FBRTdEOzs7O0dBSUc7QUFDSCxNQUFNLFVBQVUsa0JBQWtCLENBQUMsSUFBK0I7SUFDaEUsSUFBSSxJQUFJLElBQUksSUFBSTtRQUFFLE9BQU8sRUFBRSxDQUFDO0lBQzVCLE9BQU8sSUFBSTtTQUNSLE9BQU8sQ0FBQyx3QkFBd0IsRUFBRSxHQUFHLENBQUM7U0FDdEMsT0FBTyxDQUFDLDBCQUEwQixFQUFFLEdBQUcsQ0FBQztTQUN4QyxJQUFJLEVBQUUsQ0FBQztBQUNaLENBQUMifQ==